import { Select, SelectProps } from 'antd';
import { useGetTaskCategoriesQuery } from 'app/api';
import { selectSelectedEnvId } from 'app/containers/HiikoEnv/slice/selectors';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { IOption } from 'types';

interface IProps extends SelectProps<number> {}

const TaskCategorySelect: FC<IProps> = props => {
  const envId = useSelector(selectSelectedEnvId);
  const { t } = useTranslation();

  const {
    data: taskCategories,
    isFetching: isTaskCategoriesLoading,
  } = useGetTaskCategoriesQuery({ envId: envId as number }, { skip: !envId });

  const taskCategoriesOptions: IOption[] | undefined = taskCategories?.map(
    taskCategory => ({
      value: taskCategory.id,
      label: taskCategory.name,
    }),
  );

  return (
    <Select
      loading={isTaskCategoriesLoading}
      options={taskCategoriesOptions}
      placeholder={t('TaskCategoriesSelect.Placeholder', 'Task categories')}
      {...props}
    />
  );
};

export default TaskCategorySelect;
